module.exports = __webpack_public_path__ + "img/btn-swiper-prev-02.593b78d0.svg";